export default __webpack_public_path__ + "static/media/robet_henry.bfcfa136.png";